// extracted by mini-css-extract-plugin
module.exports = {"sizeAndFitWrapper":"FitToolAndSizeChart_sizeAndFitWrapper___wG9e","sizeChartColumn":"FitToolAndSizeChart_sizeChartColumn__Rac7L"};